import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useContent } from "../app/ContentContext";

function Hero() {
  const { hero } = useContent();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start center", "end start"],
  });
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const y = useTransform(scrollYProgress, [0, 1], [0, 40]);
  return (
    <Box
      ref={ref}
      sx={{
        height: { xs: "260px", sm: "340px", md: "440px" },
        display: "flex",
        textAlign: "center",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          backgroundSize: "cover",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "url('/katle.webp')",
          backgroundPosition: "center",
          zIndex: -1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.12) 0%, rgba(0,0,0,0.05) 45%, rgba(0,0,0,0.28) 100%)",
          zIndex: -1,
        }}
      />

      <motion.div style={{ y, width: "100%" }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontSize: { xs: "1.75rem", md: "3.5rem" },
            fontWeight: 700,
            px: 2,
            color: "common.white",
            textShadow: "0 2px 6px rgba(0, 0, 0, 0.5), 0 1px 20px rgba(0, 0, 0, 0.4)",
          }}
        >
          {hero.welcome}{" "}
          {isXs && <br />}
          {hero.clinicName}
        </Typography>
      </motion.div>
    </Box>
  );
}
export default Hero;
